// services/SettingsService.js
import api from "../utils/axios";
import { ENDPOINTS } from "../utils/endpoints";

export function getSettings() {
    return api.get(ENDPOINTS.SETTINGS.BASE);
}
export function getSettingByKey(key) {
    return api.get(ENDPOINTS.SETTINGS.BY_KEY(key));
}
export function updateSetting(key, value) {
    return api.patch(ENDPOINTS.SETTINGS.BY_KEY(key), { value });
}
export function restoreSettingDefault(key) {
    return api.post(`${ENDPOINTS.SETTINGS.BY_KEY(key)}/restore-default`);
}
export function restoreAllSettingsDefaults() {
    return api.post(`${ENDPOINTS.SETTINGS.BASE}/restore-defaults`);
}
